/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const timelineMetricsSchema = z.object({
  lastScheduledAt: z.iso.datetime().nullish(),
  timelineEndDate: z.iso.date(),
  timelineStartDate: z.iso.date(),
});
